// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';

import App from './App';

Vue.config.productionTip = false;
Vue.use(VueLocalStorage);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  localStorage: {
    'twitdeck.channelIds': { type: Array, default: [] },
  },
});



// WEBPACK FOOTER //
// ./src/main.js